document.addEventListener('DOMContentLoaded', function () {

    devtricker_checkAndFillLikeIcon();
    devtricker_attachPostLikeOnClick();
});

function devtricker_attachPostLikeOnClick() {
    let button = devtricker_dom_get_portLikeButton();

    if (button) {
        button.addEventListener('click', async function () {
            devtricker_perform_postLikeToggleOnClick();
        });
    }
}

async function devtricker_checkAndFillLikeIcon() {

    if (!devtricker_getTheLoggedUserId()) return;

    const postId = devtricker_getThePostId();

    if (postId) {

        const likedInSession = devtricker_session_post_like_isPostLiked(postId);
        const liked = likedInSession || await devtricker_ajax_checkIfUserLikedPost(postId);

        if (liked) {
            devtricker_dom_setchangeLikeIconToFilledAnnimated();
        }

        if (liked && !likedInSession) {
            devtricker_session_post_like_savePostInLikedPosts(postId);
        }
    }
}